// postingTypesService.js

import { AccountsAPI } from "api/axios.config";
import CONSTANT from "CONSTANT/Matter/PostingTypes";

function resolveGroup(type) {
  switch (type) {
    case CONSTANT.OP:
      return "office";
    case CONSTANT.CP:
      return "client";
    case CONSTANT.BP:
      return "all";
    case CONSTANT.BNKP:
      return "bank";
    case CONSTANT.PI:
      return "purchase";
    case CONSTANT.DIS:
      return "disbursement";
    case CONSTANT.TRANS:
      return "transfers";
    case "chits":
      return "chits";
    default:
      return "all";
  }
}

export const getSupplierPostings = (
  page,
  limit,
  supplierRef,
  IncludeReversals,
  FromDate,
  ToDate,
  type,
) => {
  let url = `/Postings/Supplier/${supplierRef}`;
  const queryParams = new URLSearchParams();

  if (type) {
    queryParams.append("type", type);
  }

  if (IncludeReversals) {
    queryParams.append("IncludeReversals", IncludeReversals);
  }

  queryParams.append("page", page);
  queryParams.append("limit", limit);

  if (FromDate) {
    queryParams.append("FromDate", FromDate);
  }
  if (ToDate) {
    queryParams.append("ToDate", ToDate);
  }

  const qs = queryParams.toString();
  if (qs) {
    url += `?${qs}`;
  }
  return AccountsAPI.get(url);
};

export const getNominalRef = (
  page,
  limit,
  nominalRef,
  IncludeReversals,
  FromDate,
  ToDate,
) => {
  let url = `/Postings/Nominal/${nominalRef}`;
  if (IncludeReversals) {
    url += `?IncludeReversals=${IncludeReversals}&page=${page}&limit=${limit}`;
  }
  if (!IncludeReversals) {
    url += `?page=${page}&limit=${limit}`;
  }
  if (FromDate) {
    url += `&FromDate=${FromDate}`;
  }
  if (ToDate) {
    url += `&ToDate=${ToDate}`;
  }
  return AccountsAPI.get(url);
};

const getPostingTypes = async (type) => {
  const group = resolveGroup(type);

  const fields = [
    "name",
    "code",
    "display",
    ...(type === "chits" || type === "all" ? ["displayFields"] : []),
  ];

  const url = `/postingtypes?${new URLSearchParams({
    group,
    fields: fields.join(","),
  }).toString()}`;

  const res = await AccountsAPI.get(url);
  return res?.data?.data || [];
};

const getPostingTypeDetails = async (type) => {
  const fields = ["name", "code", "display", "displayFields"];

  const url = `/postingtypes/${type}?${new URLSearchParams({
    fields: fields.join(","),
  }).toString()}`;

  const res = await AccountsAPI.get(url);
  return res?.data?.data || [];
};

export { getPostingTypes, getPostingTypeDetails };
